var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_vm._v(" thermondo "+_vm._s(_vm.currentYear)+" | "),_c('a',{attrs:{"href":"https://www.thermondo.de/intern/impressum/","target":"_blank"}},[_vm._v(" Impressum ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }